import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPokemonComponent } from './simple-icons-pokemon.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPokemonComponent ],
    exports:      [ SimpleIconsPokemonComponent ],
    bootstrap:    []
})
export class SimpleIconsPokemonModule {}
